export default __webpack_public_path__ + "997265f1bf214691cdcb0bb64a4fdb70.ttf";